import React from 'react';
import { Accordion, Icon } from 'semantic-ui-react';
import ModifierSetBasic from './ModifierSetBasic';

const ModifierSetsBasic = ({ modifierSets }) => {
  const panels = [
    {
      key: 'addons',
      title: 'Options',
      content: {
        content: (
          <React.Fragment>
            {modifierSets.map(({ _id: modifierSetId }) => (
              <ModifierSetBasic modifierSetId={modifierSetId} key={modifierSetId} />
            ))}
          </React.Fragment>
        ),
      },
    },
  ];

  return modifierSets.length > 0 && <Accordion panels={panels} className="fcfm-modifier-sets" />;
};

export default ModifierSetsBasic;
